export default "__VITE_ASSET__82b938b9__"